import React from "react";
import { Search, Bell } from "lucide-react";

export default function TopBar({ title }) {
  const time = new Date().toLocaleString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <header className="sticky top-0 z-20 h-16 border-b border-white/5 bg-[#0a0a0b]/85 backdrop-blur-xl" data-testid="dashboard-topbar">
      <div className="h-full px-6 flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className="font-mono-apex text-[9px] uppercase tracking-[0.3em] text-zinc-500">apex · sentinel</div>
          <div className="font-display text-lg text-white truncate">{title}</div>
        </div>

        <div className="hidden md:flex items-center gap-3 flex-1 max-w-md">
          <div className="relative w-full">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
            <input
              placeholder="Query intelligence…"
              className="w-full pl-10 pr-4 py-2 bg-[#121214] border border-white/5 font-mono-apex text-xs text-white placeholder:text-zinc-600 focus:outline-none focus:border-white/15"
              data-testid="topbar-search"
            />
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden md:flex items-center gap-2">
            <span className="live-dot" />
            <span className="font-mono-apex text-[10px] uppercase tracking-[0.25em] text-zinc-300">live</span>
            <span className="font-mono-apex text-[10px] uppercase tracking-[0.2em] text-zinc-600">{time}</span>
          </div>
          <button className="text-zinc-400 hover:text-white relative" data-testid="topbar-notifications">
            <Bell size={18} strokeWidth={1.5} />
            <span className="absolute top-0 right-0 w-1.5 h-1.5 rounded-full bg-[#dc2626]" />
          </button>
        </div>
      </div>
    </header>
  );
}
